document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 749) {
    const productInfo = document.querySelector('[data-product]');
    const buyButton = document.querySelector('[data-buy-button]');
    const footer = document.querySelector('[data-footer]');
    if (!productInfo || !buyButton || !footer) return;
    function debounce(func, delay) {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, delay);
      };
    }
    function checkVisibility() {
      const productInfoRect = productInfo.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();
      const isProductInfoVisible = productInfoRect.bottom > 0 && productInfoRect.top < window.innerHeight;
      const isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
      if (!isProductInfoVisible && !isFooterVisible) {
        buyButton.classList.add('sticky-button');
      } else {
        buyButton.classList.remove('sticky-button');
      }
    }
    window.addEventListener('scroll', debounce(checkVisibility, 50));
    window.addEventListener('resize', debounce(checkVisibility, 50));
    checkVisibility();
  }
});
